import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  Box,
} from "@chakra-ui/react";

interface ComponentModalProps {
  isOpen: boolean;
  onClose: () => void;
  component: React.ReactNode;
}

const ComponentModal: React.FC<ComponentModalProps> = ({
  isOpen,
  onClose,
  component,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full" isCentered>
      <ModalOverlay bg="blackAlpha.900" />
      <ModalContent
        bg="transparent"
        boxShadow="none"
        maxW="100vw"
        maxH="100vh"
        m={0}
        p={0}
      >
        <ModalCloseButton
          color="white"
          position="fixed"
          top={4}
          right={4}
          zIndex={2}
        />
        <Box
          position="relative"
          height="100vh"
          width="calc(100vh * 9/16)"
          maxWidth="90vw"
          display="flex"
          alignItems="center"
          justifyContent="center"
          margin="0 auto"
        >
          {component}
        </Box>
      </ModalContent>
    </Modal>
  );
};

export default ComponentModal;
